document.addEventListener('DOMContentLoaded', function () {
  var formSection = document.getElementById('shopify-section-template--28532936475008__178272906393b490ed');

  if (formSection) {
    formSection.style.transition = 'opacity 0.3s ease, max-height 0.3s ease';
    formSection.style.overflow = 'hidden';
    formSection.style.opacity = '0';
    formSection.style.maxHeight = '0';
  }

  var wholesaleBtn = document.querySelector('a[href="#wholesale-registration-form"]');
  if (wholesaleBtn && formSection) {
    wholesaleBtn.addEventListener('click', function (e) {
      e.preventDefault();
      formSection.style.maxHeight = '2000px';
      formSection.style.opacity = '1';
      formSection.style.overflow = 'visible';
      formSection.scrollIntoView({ behavior: 'smooth' });
    });
  }
});
